import React from 'react'

import {ItemIconClass} from "../../gd/const/item-icon/icon/item-icon-class"
import {SelectTaskTypeRenderValue} from "./@types"

type SingleProps = {
    value            : any
    placeholder      : string
    renderValue      : SelectTaskTypeRenderValue
    renderValueFunc? : (value:any) => React.ReactNode
    onClick          : callback
}

export function SelectTaskTypeValueSingle(props:SingleProps) {
    const value = props.value

    const taskType:any = (value) ? gd.session.taskTypes.get(value) : false

    let valueIcon:string|false = false
    let valueLabel = props.placeholder
    if (taskType) {
        valueIcon = ItemIconClass[taskType.icon]
        valueLabel = taskType.name
    }

    let res:React.ReactNode = false
    let curValueClasses = Classes('cur-value', 'single-value', 'pop-target', {
        'no-value': !taskType
    })

    switch (props.renderValue) {

        case 'circle-btn-28':
            const taskIcon = value ? ItemIconClass[taskType.icon] : 'i5-task'
            curValueClasses = Classes('cur-value','pop-target', taskIcon, 'icon', {
                'no-value': !value
            })
            return <div className={curValueClasses} onClick={props.onClick} />

        case 'form':
            return (
                <div className={curValueClasses} onClick={props.onClick}>

                    {valueIcon && <span className={Classes('icon',valueIcon)}></span>}
                    <span>{valueLabel}</span>
                    <div className="arrow-icon i5-big-angle-down" />
                </div>
            )


        case 'selector':
            curValueClasses = Classes('cur-value','pop-target', {
                'no-value': !value
            })

            const iconClass = Classes('cur-value-icon',ItemIconClass[taskType.icon])

            return (
                <div className={curValueClasses} onClick={props.onClick}>
                    <div className={iconClass}> </div>
                    {valueLabel}
                    <div className="arrow-icon i5-big-angle-down"> </div>
                </div>
            )

        case 'func':
            res = props.renderValueFunc(value)
            break
    }

    return (
        <div className={curValueClasses} onClick={props.onClick}>
            {res}
        </div>
    )
}

type MultiProps = {
    values          : any[]
    placeholder     : string
    renderValue     : SelectTaskTypeRenderValue
    onClick         : callback
}

export function SelectTaskTypeValueMulti(props:MultiProps) {
    const values = props.values
    const taskTypesCount = values && values.length ? values.length : 0

    let result

    if (taskTypesCount<1) {
        result = <span>{props.placeholder}</span>
    } else {
        result = values.map(taskTypeId=>{

            const taskType = gd.session.taskTypes.get(taskTypeId)
            if (!taskType) {
                return null
            }

            return <div key={taskTypeId} className="item">{taskType.name}</div>
        })
    }

    const curValueClasses = Classes('cur-value', 'pop-target', 'multi-select', {
        'no-value': taskTypesCount < 1
    })

    if (props.renderValue !== 'form') {
        console.error("Task Type Select Multi Value Render not supported for", props.renderValue)
        return null
    }

    return (
        <div className={curValueClasses} onClick={props.onClick}>
            {result}
            <div className="cf"></div>
            <div className="i5-big-angle-down" />
        </div>
    )
}
